import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, EffectFade } from "swiper/modules";
import IconBox from "../components/icon-box";
import { mousewheel } from "../App";

const Section7 = ({ isActive = false, onSlideChange }) => {
  return (
    <Swiper
      className="icon_box"
      direction="vertical"
      speed={700}
      mousewheel={mousewheel}
      nested
      effect="fade"
      preventInteractionOnTransition
      modules={[EffectFade, Mousewheel]}
      onSlideChange={onSlideChange}
    >
      <SwiperSlide>
        <IconBox isActive={isActive} useAnimation />
      </SwiperSlide>
      <SwiperSlide className="title_wrap">
        <IconBox isActive={isActive} />
        <div className="dim" />
        <h2 className="icon_title">
          We deliver <br className="mob_br" />
          peace-of-mind technology
          <br />
          that you can count on, <br className="mob_br" />
          every day.
        </h2>
      </SwiperSlide>
    </Swiper>
  );
};

export default Section7;
